<template>
  <EmptyState class="page-result mt-8" v-bind="propsData">
    <template #illustration>
      <Picture maxWidth="400" class="mb-12" :src="illustration"/>
      <span class="text-h3 font-weight-medium" v-text="propsData"/>
      <Link class="mt-1" :href="href" color="primary">
        <span class="text-paragraph-1" v-text="actionText"/>
        <Icon class="ml-1" icon="$web-system-external-outline" small/>
      </link>
    </template>
  </EmptyState>
</template>

<script>
import { Link, EmptyState, Picture, Icon } from '@locaweb/design-system-vue'
import EmptyResultIllustration from '@/assets/results/empty.svg'

export default {
  name: 'PageSupportPanel',
  props: {
    textResults: {
      type: Object,
      required: true
    },
    currentUser: {
      type: Object,
      required: true
    }
  },
  components: {
    EmptyState,
    Link,
    Picture,
    Icon
  },
  computed: {
    actionText () {
      return this.textResults.supportPanel.action
    },
    actionProps () {
      return {
        ...!this.externalAction && this.actionRoute && { to: this.actionRoute },
        ...this.externalAction && this.actionRoute && {
          href: this.actionRoute,
          target: '_blank'
        }
      }
    },
    propsData () {
      return `Olá, ${this.currentUser.name}`
    },
    illustration () {
      return EmptyResultIllustration
    },
    href () {
      return process.env.VUE_APP_SUPPORT_PANEL
    }
  }
}
</script>
